import React, { useEffect, useState } from "react";
import OtpInput from "react-otp-input";
import Button from "../../../../common/ekedc-components/button/Button";
import CommonDialog from "../../../../common/components/dialog/CommonDialog";
import styles from "./transfer-unit-pin-modal.module.scss";

const CrossIcon: React.FC = () => (
	<svg width="22" height="22" viewBox="0 0 22 22" fill="none">
		<path d="M5.5 5.5L16.5 16.5M16.5 5.5L5.5 16.5" stroke="var(--app-primary-text)" strokeWidth="1.5" strokeLinecap="round" />
	</svg>
);

interface TransferUnitPinModalProps {
	onClose: () => void;
	onSubmit: (pin: string) => Promise<void> | void;
	onForgotPin?: () => void;
	submitting?: boolean;
}

export const TransferUnitPinModal: React.FC<TransferUnitPinModalProps> = ({
	onClose,
	onSubmit,
	onForgotPin,
	submitting = false,
}) => {
	const [pin, setPin] = useState("");

	useEffect(() => {
		const onKey = (e: KeyboardEvent) => {
			if (e.key === "Escape") onClose();
		};
		document.addEventListener("keydown", onKey);
		return () => document.removeEventListener("keydown", onKey);
	}, [onClose]);

	const handleSubmit = async (e: React.FormEvent) => {
		e.preventDefault();
		if (pin.length !== 4 || submitting) return;
		await onSubmit(pin);
	};

	return (
		<CommonDialog onCloseDialog={onClose} noPadding={true} borderRadius="21.67px">
			<div className={styles.modal}>
				<header className={styles.toolbar}>
					<button type="button" className={styles.closeBtn} onClick={onClose} aria-label="Close">
						<CrossIcon />
					</button>
					<h2 className={styles.title}>Enter Transaction PIN</h2>
					<div className={styles.toolbarSpacer} />
				</header>

				<form className={styles.body} onSubmit={handleSubmit}>
					<div className={styles.otpRow}>
						<OtpInput
							value={pin}
							onChange={setPin}
							numInputs={4}
							inputType="password"
							shouldAutoFocus
							containerStyle={styles.otpContainer}
							renderInput={(props, idx) => (
								<input
									{...props}
									className={`${styles.otpInput} ${
										idx === pin.length && pin.length < 4 ? styles.otpInputFocus : ""
									}`}
								/>
							)}
						/>
					</div>

					<button
						type="button"
						className={styles.forgotPinLink}
						onClick={onForgotPin}
						disabled={!onForgotPin}
					>
						Forgot Transaction Pin?
					</button>

					<Button
						type="submit"
						text="Send"
						disabled={pin.length !== 4}
						loading={submitting}
						loadingText="Sending…"
					/>
				</form>
			</div>
		</CommonDialog>
	);
};

export default TransferUnitPinModal;
